import React from "react";

const PageHeader = ({ text }: { text: string }) => {
  return <p className="text-2xl font-semibold mb-4 text-center text-main-color-text">{text}</p>;
};

export default PageHeader;
